import { useState } from "react";
import VendorBrowser from "../marketplace/VendorBrowser";
import { uploadImage } from "../lib/upload";
import { track } from "../lib/api";

// Stage 5 — Photography. Marketplace-backed. AI quote includes shoot scope,
// floor plan, drone (if eligible), and turnaround.
//
// Photo delivery: no photographer-facing upload portal exists yet (that's a
// separate two-sided-marketplace piece) — for now the seller uploads the
// delivered shoot here on the photographer's behalf. Whatever lands in
// state.data.photos is what MlsStage pulls into the listing.
const MAX_PHOTOS = 12;

export default function PhotographyStage({ state, journey, update }) {
  const [uploading, setUploading] = useState(false);
  const [err, setErr] = useState(null);
  const photos = state.data?.photos || [];

  const onFiles = async (e) => {
    const files = Array.from(e.target.files || []).slice(0, MAX_PHOTOS - photos.length);
    if (!files.length) return;
    setUploading(true);
    setErr(null);
    try {
      const urls = await Promise.all(files.map((f) => uploadImage(f, "listing")));
      update({ data: { ...(state.data || {}), photos: [...photos, ...urls] } });
      track("seller_photography_photos_uploaded", { count: urls.length });
    } catch {
      setErr("Upload failed — try again.");
    }
    setUploading(false);
    e.target.value = "";
  };

  const removePhoto = (url) => {
    update({ data: { ...(state.data || {}), photos: photos.filter((p) => p !== url) } });
  };

  return (
    <>
      <p style={{ color: "#5b7365", fontSize: 14, lineHeight: 1.7, margin: "0 0 14px" }}>
        Pick a photographer. AI generates a quote with the exact shoot scope —
        interior HDR, floor plan, drone, twilight — tied to your property and listing.
      </p>
      <VendorBrowser
        type="photographer"
        journey={journey}
        state={state}
        update={update}
        stageId="photography"
      />

      <div style={{ marginTop: 24, paddingTop: 20, borderTop: "1px solid #f0f4f2" }}>
        <div style={{ fontFamily: "'DM Mono',monospace", fontSize: 10, color: "#9aa9a0", letterSpacing: "0.08em", textTransform: "uppercase", marginBottom: 8 }}>
          Shoot delivered? Upload the photos here
        </div>
        <p style={{ fontSize: 12, color: "#5b7365", marginBottom: 12, lineHeight: 1.6 }}>
          These carry straight into your MLS listing — no need to re-upload there.
        </p>

        {photos.length > 0 && (
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(100px,1fr))", gap: 8, marginBottom: 12 }}>
            {photos.map((url) => (
              <div key={url} style={{ position: "relative", aspectRatio: "1", borderRadius: 10, overflow: "hidden", border: "1.5px solid #d8ede6" }}>
                <img src={url} alt="listing" style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }} />
                <button
                  type="button"
                  onClick={() => removePhoto(url)}
                  style={{ position: "absolute", top: 3, right: 3, background: "rgba(21,45,33,0.75)", color: "#fff", border: "none", borderRadius: "50%", width: 20, height: 20, cursor: "pointer", fontSize: 11, lineHeight: 1 }}
                >×</button>
              </div>
            ))}
          </div>
        )}

        {photos.length < MAX_PHOTOS && (
          <label className="s-link-btn" style={{ display: "inline-block", cursor: "pointer" }}>
            {uploading ? "Uploading…" : "+ Upload photos"}
            <input type="file" accept="image/jpeg,image/png,image/webp" multiple onChange={onFiles} disabled={uploading} style={{ display: "none" }} />
          </label>
        )}
        {err && <div className="s-intake-err" style={{ marginTop: 8 }}>{err}</div>}
      </div>
    </>
  );
}
